import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RemoveCircleSharp } from "@mui/icons-material";
import { Avatar, IconButton } from "@mui/material";
import MainContent from "components/Containers/MainContent";
import Dialog from "components/Dialog/Dialog";
import ReactTable from "components/ReactTable"
import { actions as WorkersActions, selectors as WorkersSelectors } from "store/modules/workers";
import { useTranslation } from "react-i18next";

function PreferredWorkers() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showRemovePreferredDialog, setShowRemovePreferredDialog] = useState(false)
  const [workerId, setWorkerId] = useState()
  const pageInfo = useSelector(WorkersSelectors.getPreferredWorkersPaginationData)
  const preferredWorkerData = useSelector(WorkersSelectors.getPreferredListData({ part: "data" }))
  const pageFilter = useSelector(WorkersSelectors.getPreferredListData({ part: "filter" }))
  const pageSort = useSelector(WorkersSelectors.getPreferredListData({ part: "sort" }))
  const fetchData = useCallback(({ pageIndex, filters, sortBy }) => {
    dispatch(WorkersActions.changePreferredWorkersFilter(filters));
    dispatch(WorkersActions.changePreferredWorkersSort(sortBy));
    dispatch(WorkersActions.fetchPreferredWorkers(pageIndex));
  }, []);

  const columns = [
    {
      Header: "",
      id: "signedProfileImageUrl",
      disableFilters: true,
      disableSortBy: true,
      accessor: ({ signedProfileImageUrl }) => {
        return signedProfileImageUrl;
      },
      Cell: ({ row: { original: { firstName, signedProfileImageUrl } } }) => (
        <>
          <Avatar alt={firstName} src={signedProfileImageUrl} />
        </>
      ),
    },
    {
      Header: t("common_table_column_firstName"),
      id: "firstName",
      accessor: ({ firstName }) => {
        if (!firstName) {
          return <i>Missing first name</i>;
        }

        return firstName;
      },
    },
    {
      Header: t("common_table_column_lastName"),
      id: "lastName",
      accessor: ({ lastName }) => {
        if (!lastName) {
          return <i>Missing last name</i>;
        }

        return lastName;
      },
    },
    {
      Header: t("common_table_column_location"),
      id: "city",
      accessor: ({ city, region }) => {
        if (!city || !region) {
          return <i>Missing location</i>;
        }
        return `${city}, ${region}`;
      },
    },
    // {
    //   Header: t("common_table_column_rating"),
    //   id: "rating",
    //   accessor: ({ rating }) => {
    //     if (!rating) {
    //       return <i>Not rated.</i>;
    //     }
    //     return rating;
    //   },
    //   disableFilters: true,
    // },
    {
      Header: "",
      id: "id",
      accessor: "id",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row: { original } }) => {
        return (
          <>
            <IconButton onClick={() => showRemoveDialog(original.id)}>
              <RemoveCircleSharp color="error" />
            </IconButton>
          </>
        )
      }
    },
  ];

  const hideRemovePreferred = () => setShowRemovePreferredDialog(false);

  const showRemoveDialog = (id) => {
    setWorkerId(id)
    setShowRemovePreferredDialog(true)
  }

  const handleRemovePreferred = () => {
    dispatch(WorkersActions.removeBanWorker(workerId, 'preferred'))
    setShowRemovePreferredDialog(false)
  }

  return (
    <>
      <MainContent>
        <ReactTable
          columns={columns}
          data={preferredWorkerData}
          fetchData={fetchData}
          defaultFilter={pageFilter}
          defaultSort={pageSort}
          currentPage={pageInfo.currentPage}
          defaultPageSize={pageInfo.pageIndex}
          loading={pageInfo.isLoading}
          pageCount={pageInfo.totalCount}
        />
        <Dialog
          open={showRemovePreferredDialog}
          title={t("common_labels_are_you_sure")}
          onClose={hideRemovePreferred}
          onConfirm={handleRemovePreferred}
          onCancel={hideRemovePreferred}
          alertType="warning"
          icon="remove_circle"
        />
      </MainContent>
    </>
  );
}

export default PreferredWorkers;
